'use strict';

import co from 'co';

const TYPE_JSON = 'json',
      TYPE_TEXT = 'text',
      DEFAULT_FETCH_OPTIONS = {
          credentials: 'same-origin'
      },
      DEFAULT_OPTIONS = {
          type: TYPE_JSON,
          interval: 1000,
          startImmediately: false,
          fetchOptions: DEFAULT_FETCH_OPTIONS,
          onError: e => {
              // do nothing
          }
      };

/*
    url = {String}                      // required
    callback = {Function}               // required
    options = {                         // optional
        type: {String},                 // optional; 'json' or 'text'; default is 'json'
        interval: {Number},             // optional; in ms; default is 1000
        startImmediately: {Boolean},    // optional; default is false
        fetchOptions: {Object}          // optional
        onError: {Function}             // optional
    }
*/

function handleSpecialResponse(response)
{
    // request timeout
    if (response.status == 408) {
        location.reload(true);
    }

    return response;
}

function toType(type, response)
{
    switch (type) {
        case TYPE_TEXT:
            return response.text();

        case TYPE_JSON:
        default:
            return response.json();
    }
}

function augmentUrl(url)
{
    return `${url}&_=${Date.now()}`;
}

function augmentOptions(options)
{
    return Object.assign({}, DEFAULT_OPTIONS, options);
}

function poll(url, callback, options)
{
    function wait(ms)
    {
        return done => setTimeout(done, ms);
    }

    options = augmentOptions(options);

    co(function* () {
        let done = false;
        let startImmediately = options.startImmediately;
        while (!done) {
            if (startImmediately) {
                startImmediately = false;
            } else {
                yield wait(options.interval);
            }

            if (done) {
                break;
            }

            let response = yield fetch(augmentUrl(url), options.fetchOptions);
            response = handleSpecialResponse(response);
            if (response.ok) {
                Promise.resolve(toType(options.type, response))
                       .then(response => {
                          done = callback(response);
                       });
            } else {
                return Promise.reject(new Error(response.statusText));
            }
        }
    })
    .catch(e => {
        console.log(e);
        options.onError(e);
    });
}

function pollOnce(url, callback, options)
{
    url = augmentUrl(url);
    options = augmentOptions(options);

    return fetch(url, options.fetchOptions)
           .then(response => handleSpecialResponse(response))
           .then(response => response.ok ? toType(options.type, response) : Promise.reject(new Error(response.statusText)))
           .then(response => callback(response))
           .catch(e => {
               console.log(e);
               options.onError(e);
           });
}

export default { poll, pollOnce, TYPE_JSON, TYPE_TEXT };